import Component from '@ember/component';

export default Component.extend({
  classNameBindings: ['componentClasses', 'jsBindingClass', 'testBindingClass'],
});
